import { indexItems } from '@/mocks/homeData';

export default function Index() {
  return (
    <section id="index" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 text-center">
          剧集索引
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {indexItems.slice(0, 5).map((item) => (
            <a
              key={item.title}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-100 rounded-xl hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-primary-400 group-hover:text-primary-500 transition-colors`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">{item.title}</span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 mt-3 md:mt-4">
          {indexItems.slice(5).map((item) => (
            <a
              key={item.title}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-100 rounded-xl hover:bg-accent-50 border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-accent-400 group-hover:text-accent-500 transition-colors`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-accent-600 transition-colors whitespace-nowrap">{item.title}</span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}